import { render, staticRenderFns } from "./ExpiredWarrant.vue?vue&type=template&id=41064894&scoped=true&"
import script from "./ExpiredWarrant.js?vue&type=script&lang=js&"
export * from "./ExpiredWarrant.js?vue&type=script&lang=js&"
import style0 from "./ExpiredWarrant.vue?vue&type=style&index=0&id=41064894&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41064894",
  null
  
)

export default component.exports